<script setup lang="ts">

import FeaturePanel from './FeaturePanel.vue';
import GetTheAppButton from '@components/GetTheAppButton/GetTheAppButton.vue';

</script>

<template>

    <div class="max-w-5xl mx-auto px-4">
                
        <h1 class="text-4xl font-semibold text-center mt-12">
            And great value offers and rewards in the <br class="hidden md:block"/>Carbucks Marketplace
        </h1>
                
        <FeaturePanel :is-reversed="true">

            <template #image>
                <img src="@/assets/images/Screenshots/marketplace.png" class="w-4/5 md:w-full"/>
            </template>
          
            <template #headline>
               Marketplace
            </template>          

            <div class="flex flex-col gap-4">
                <h1 class="text-2xl font-semibold pb-4">
                    Your <span class="text-primary-600 uppercase font-bold">one-stop shop</span> for 
                    <br>
                    Automotive <i>and</i> Lifestyle Rewards
                </h1>
            </div>

            <p class="mb-2">
                The Carbucks Marketplace gives you access to exclusive 
                rewards and offers, conveniently split into 
                Automotive and Lifestyle categories.
            </p>

            <p class="mb-2">
                Carbucks is the only provider of uniquely Automotive rewards, 
                giving you access to savings and offers that you won't find anywhere else.
            </p>

            <p class="mb-8">
                And we've partnered with Automotive dealerships and service providers, across 
                the country, to bring you exclusive Carbucks savings on common car maintenance
                activities.
            </p>
            
            <GetTheAppButton />

        </FeaturePanel>
                
        <h1 class="text-4xl font-semibold text-center mt-8">
            Earn your cashback in automotive or in lifestyle
        </h1>
                
        <div class="grid grid-cols-1 md:grid-cols-2 gap-8 my-16">
            
            <!-- AUTOMOTIVE -->
            <div class="bg-gray-50 p-6 flex flex-col gap-y-4 rounded-lg">
                <img src="@/assets/images/HowItWorks/category-automotive.png" class="w-full" />
                <h1 class="text-2xl font-semibold mt-1">Automotive</h1>
                <div class="flex flex-col gap-2">
                    <p>
                        Welcome to Carbucks Automotive Marketplace, where manufacturers, 
                        dealerships and service providers collaborate to bring you great values
                        offers to reduce the cost of vehicle ownership.
                    </p>
                    <p>
                        Enjoy more choice, competitive pricing and hassle-free services, making
                        your engagement with automotive, stress free with great value.
                    </p>
                </div>
            </div>

            <!-- LIFESTYLE -->
            <div class="bg-gray-50 p-6 flex flex-col gap-y-4 rounded-lg">
                <img src="@/assets/images/HowItWorks/category-lifestyle.png" class="w-full" />
                <h1 class="text-2xl font-semibold mt-1">Lifestyle</h1>
                <div class="flex flex-col gap-2">
                    <p>
                        Indulge in convenience and luxury in the Carbucks Lifestyle Marketplace.  
                        Enjoy great offers in fashion, wellness, leisure and more.
                    </p>
                    <p>
                        And every dollar you spend in Lifestyle, brings you cashback that you can
                        use to reduce the cost of your automotive spend.
                    </p>
                </div>
            </div>

        </div>

    </div>

</template>